module.exports = __webpack_public_path__ + "static/media/about-section-image.31b1cf2a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Imgs/about-section-image.svg
// module id = 63
// module chunks = 0